import { ChangeDetectionStrategy, Component, Inject, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { L10N_LOCALE, L10nLocale } from 'angular-l10n';
import {  FilterValueType } from '../../filtered-search.component';

@Component({
  selector: 'slide-toggle-filter',
  styleUrl: '../filtered-search-option.component.scss',
  template: `
    <mat-slide-toggle
      (keyup)="$event.stopPropagation(); $event.preventDefault()"
      (click)="$event.stopPropagation()"
      [formControl]="control"
      [attr.data-test]="'filter-boolean-filter'"
    >
      {{ placeholder || 'Enable' }}
    </mat-slide-toggle>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class SlideToggleFilterComponent {
  @Input() control: FormControl<FilterValueType>;
  @Input() placeholder?: string;

  constructor(@Inject(L10N_LOCALE) public locale: L10nLocale) {}
}
